export const rules = {
  name: [{ required: true, message: "请输入清单名称" }],
  unit: [{ required: true, message: "请输入结算单位" }],
  budgetCount: [{ required: true,validator:(rule,value)=>{
    return new Promise((resolve,reject)=>{
      if(value ===0){
        reject("工程量必须大于0")
      }else if(value>0){
        resolve('')
      }else{
        reject('请输入工程量')
      }
    })
  } }],
  budgetPrice: [{ required: true, validator:(rule,value)=>{
    return new Promise((resolve,reject)=>{
      if(value ===0){
        reject("综合单价必须大于0")
      }else if(value>0){
        resolve('')
      }else{
        reject('请输入综合单价')
      }
    })
  }, }],
};
